import styled from "@emotion/styled";
import LoadingOverlayWrapper from "react-loading-overlay-ts";

export const Wrapper = styled(LoadingOverlayWrapper)(() => ({
  fontSize: "12px",
  display: "flex",
  height: "auto",
  overflow: "auto",
  //minHeight: "100%",
  backgroundColor: "#dfdfdf",
  "& .content-container": {
    flexGrow: 1,
    height: "fit-content",
    minWidth: 500,
    backgroundColor: "white",
    padding: "12px 15px",
    marginRight: "12px",
    border: "1px solid #ddddde",
    "& .content-header": {
      display: "flex",
      alignItems: "center",
      "& .header-title": {
        flexGrow: 1
        //margin: "0 12px"
      }
    }
  },
  "& .container-progress": {
    width: "28%",
    minWidth: 310,
    margin: "10px 0px 0px 8px"
  }
}));
